import { IActionCenterDeleter } from '../../interfaces';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { DeleteWorkOrdersMutation } from '@app/pages/cmms/graphql/work-order.mutations';
import { Apollo } from 'apollo-angular';
import { timeout } from 'rxjs';

export class WoDeleter implements IActionCenterDeleter {
	constructor(
		private readonly actionCenterService: ActionCenterService,
		private readonly apollo: Apollo,
		private readonly openDialog?: (
			pks: string[],
			callback: (pks: string[]) => void
		) => void
	) {}

	async delete(pks: string[]): Promise<any> {
		const callback = (pks: string[]) => {
			this.apollo
				.mutate({
					mutation: DeleteWorkOrdersMutation,
					fetchPolicy: 'network-only',
					variables: {
						workOrders: pks,
					},
				})
				.pipe(timeout(10000))
				.subscribe(() => {
					this.actionCenterService.actionDone$.next();
				});
		};
		if (this.openDialog) {
			this.openDialog(pks, callback);
		} else {
			callback(pks);
		}
	}
}
